import { CognitoUserSession } from "amazon-cognito-identity-js";

export function parseTokens(session: CognitoUserSession): any {
	return {
		accessToken: {
			jwtToken: session.getAccessToken().getJwtToken(),
			exp: session.getAccessToken().getExpiration(),
			iat: session.getAccessToken().getIssuedAt(),
			username: session.getAccessToken().payload.username
		},
		idToken: {
			jwtToken: session.getIdToken().getJwtToken(),
			exp: session.getIdToken().getExpiration(),
			iat: session.getIdToken().getIssuedAt(),
			username: ""
		},
		refreshToken: session.getRefreshToken().getToken(),
		session: session
	};
}
